module.exports = __webpack_public_path__ + "img/status_identification.60ceff6a.svg";